
import * as angular from "angular";

export class DelayCreationDirective implements angular.IDirective {

    restrict = "A";
    terminal = true;
    priority = 1000;

    public link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor($compile: angular.ICompileService, $timeout: angular.ITimeoutService) {

        DelayCreationDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {

            var delay = parseInt($attrs["delayCreation"]) || 1000;
            var placeholder = angular.element(document.createComment("delayCreation placeholder"));

            $element.after(placeholder);
            $element.remove();

            $timeout(() => {
                $element.removeAttr("delay-creation");
                $element.attr("ng-if", $attrs["delayCreation"]);

                if (placeholder) {
                    placeholder.after($element);
                    placeholder.remove();
                }

                $compile($element)($scope);
            }, delay);
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($compile: angular.ICompileService, $timeout: angular.ITimeoutService) => new DelayCreationDirective($compile, $timeout);

        directive.$inject = ["$compile", "$timeout"];

        return directive;
    }
}
